<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <div v-if="$gate.isPurchaseManager()">
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->
            
    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>Request Details | Purchase Manager</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
<br>
<!-- main row for all icons  -->
<div class="col-lg-12">
	<div class="card card-primary card-outline">
		<div class="card-header">
			Request Data
		</div>
		<div class="card-body overflow-auto">
			<div class="col-lg-12">
				<div class="row">
					<div class="col-lg-6">
						<p><b>Job No: </b><a :href="'/purchase-manager/job-profile/'+request.job_id" target="_blank">{{request.job_no}}</a></p>
						<p><b>Item: </b>{{request.item}}</p>
						<p><b>Part: </b>{{request.part}}</p>
						<p>
							<b>Status: </b>
							<h5 v-if="request.status == 'Fulfilled'"><span class="badge badge-success">{{request.status}}</span></h5>
							<h5 v-else><span class="badge badge-danger">{{request.status}}</span></h5>
						</p>
						<p><b>Urgency: </b>{{request.urgency}}</p>
						<p><b>Branch: </b>{{request.from_branch}}</p>
						<p><b>Requested By: </b>{{request.requested_name}}</p>
						<p><b>Requested At: </b>{{request.created}}</p>
						<p><b>Dispatched At: </b>{{request.dispatched_date}}</p>
						<p><b>Received At: </b>{{request.received_date}}</p>
						<p><b>Remarks: </b>{{request.remarks}}</p>
					</div>
					<div class="col-lg-6">
						<div class="form-group">
							<label>Assign Item</label>
							<v-select v-model="inv_item" :options="inventory" label="display_name" :reduce="inventory => inventory.id" placeholder="Choose item" :value="inventory => inventory.id"></v-select>
						</div>
						<div class="form-group">
							<label>Consumed Price</label>
							<input v-model="inv_item_price" placeholder="Enter Price" class="form-control">
						</div>
						<div class="col-md-12">
							<div class="row">
								<div class="col-md-4">
									<div class="form-group">
							<button class="btn btn-primary" @click="assign">Assign</button>
						</div>
								</div>
						<div class="col-md-4">
							<div class="form-group" v-if="!request.dispatched_date">
							<button class="btn btn-success" @click="dispatch" v-if="!request.dispatched_date">Dispatch</button>
						</div>
						</div>
						<div class="col-md-4">
							<div class="form-group" v-if="request.status != 'Declined' || request.status != 'Approved'">
								<button class="btn btn-danger" @click="declineModal"><i class="fa fa-times"></i> Decline</button>
							</div>
						</div>
							</div>
						</div>
					</div>
				</div>
			</div>
    </div>
	</div>
</div>
<!-- row end -->
    </section>
    <!-- /.content -->

<div class="modal" tabindex="-1" role="dialog" id="declineModal">
 <div class="modal-dialog modal-lg" role="document">
 <div class="modal-content">
 <div class="modal-header">
        <h5 class="modal-title">Decline Order</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
					<div class="modal-body">
						<h3>Are you sure you want to decline the request?</h3>
					</div>
					<div class="modal-footer">
						<button class="btn btn-success" @click="decline" data-dismiss="modal">Yes</button>
						<button class="btn btn-secondary" data-dismiss="modal">No</button>
					</div>
				</div>
				</div>
				</div>
    
<!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isPurchaseManager()">
             <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
		 export default {
        mounted() {
            console.log('Component mounted.')
        },
        
        created(){
        	this.getRequest();
        	this.getInventory();
        },
        
        data(){
        	return {
        		request: [],
        		inventory: [],
        		inv_item: '',
        		inv_item_price: ''
        	}
        },
        
        methods: {
        	getRequest(){
        		axios.post("/api/getRequest", {id: this.$route.params.id})
        		.then(response => {
        			this.request = response.data;
        		})
        	},
        	
        	getInventory(){
        		axios.post("/api/getBranchInventory")
        		.then(response => {
        			this.inventory = response.data;
        		})
        	},
        	
        	assign(){
        		axios.post("/api/fulfillRequest", {id: this.inv_item, request: this.request.job_id, price: this.inv_item_price, req_id: this.request.id})
        		.then(response => {
        			if(response.data == 200)
        			 toast.fire({
        			 	icon: 'success',
        			 	title: 'Request Fulfilled'
        			 });
        			else
        				toast.fire({
        			 		icon: 'error',
        			 		title: 'Failed'
        			 	});
        		})
        		.catch(() => {
        			toast.fire({
        			 		icon: 'error',
        			 		title: 'Failed'
        			 	});
        		})
        	},
        	
        	dispatch(){
        		axios.post("/api/dispatchRequest", {request: this.request.id})
        		.then(response => {
        			if(response.data == 200){
        			 	toast.fire({
        			 		icon: 'success',
        			 		title: 'Item Dispatched'
        			 	});
        			 	this.getRequest();
        			}
        			else
        				toast.fire({
        			 		icon: 'error',
        			 		title: 'Failed'
        			 	});
        		})
        		.catch(() => {
        			toast.fire({
        			 		icon: 'error',
        			 		title: 'Failed'
        			 	});
        		})
        	},
        	
        	declineModal(){
    				$("#declineModal").modal('show');
    			},
    			
    			decline(){
    				axios.post("/api/declineRequest", {request: this.request.id})
    				.then(response => {
    					if(response.data == 200)
    					{
    						toast.fire({
    							icon: 'success',
    							title: 'Request Declined'
    						});
    						this.getRequest();
    						history.back();
    					}
    					else
    						toast.fire({
    							icon: 'error',
    							title: 'Failed'
    						});
    				})
    				.catch(() => {
    					toast.fire({
    						icon: 'error',
    						title: 'Failed'
    					});
    				})
    			},
        }
    }
</script>
